import { ISendSurveyAnswerParams } from './types';
import { THeaders } from '../../types/request';
import { fetchSendSurveyAnswer } from '../../repositories/deal-rent-announcements/v1/send-survey-answer';

export async function sendSurveyAnswer(params: ISendSurveyAnswerParams) {
  const { httpApi, logger, parameters } = params;

  const headers: THeaders = [['Content-Type', 'application/json']];

  const requestConfig = {
    headers,
  };

  try {
    await fetchSendSurveyAnswer({
      httpApi,
      parameters,
      config: { requestConfig },
    });
  } catch (error) {
    logger.warning(error, {
      description: 'Запрос send-survey-answer',
      degradation: 'Результат опроса пользователя не записался',
    });
  }
}
